<template>
  <div
    id="container"
    style="overflow-x: auto"
    class="mx-0">
    <el-dialog
      :visible.sync="isShowImageLibraryPopup"
      v-if="isShowImageLibraryPopup"
      :destroy-on-close="true">
      <ImageLibraryPopup />
    </el-dialog>
    <el-dialog
      class="custom-dialog"
      title="TẠO TIN NHẮN MẪU BẰNG EXCEL"
      :visible.sync="showExcelDialog"
      :destroy-on-close="true"
      width="500px">
      <div style="border: 1px solid #ececec; padding: 10px; border-radius: 4px">
        <div
          class="d-flex"
          style="align-items: center; justify-content: space-between">
          <span class="custom-text text-left fw-bold">Mẫu Excel tạo tin nhắn mẫu hàng loạt</span>
          <el-button
            type="primary"
            @click="downloadExcel"
            style="background-color: white; color: #327ae7; height: 32px; width: 157px; display: flex; justify-content: center; align-items: center">
            <div
              class="d-flex"
              style="align-items: center">
              <icon-v-2
                name="v2-import"
                color="#327AE7"
                size="16px"
                style="margin-right: 8px; vertical-align: middle"></icon-v-2>
              <span style="color: #327ae7; font-size: 12px">Tải mẫu tạo hàng loạt</span>
            </div>
          </el-button>
        </div>
        <div
          class="mt-2"
          style="border-top: 1px solid #ececec; padding-top: 10px">
          <span class="custom-text text-left fw-bold">Chọn tài khoản áp dụng</span>
          <el-select
            class="custom-account"
            v-model="accountId"
            @change="getMessage"
            filterable
            default-first-option
            placeholder="Tìm kiếm tài khoản..."
            style="
              width: 100%;
              height: 32px;
              gap: 0px;
              border-radius: 4px 0px 0px 0px;
              border: 1px 0px 0px 0px;
              justify: space-between;
              opacity: 0px;
              margin-top: 5px;
            ">
            <el-option
              label="Tất cả tài khoản"
              class="uppercase-label"
              :value="0"></el-option>
            <el-option
              v-for="account in app.accounts"
              :key="account.accountId"
              :label="account.swName || account.displayName"
              :value="account.accountId"></el-option>
          </el-select>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <span class="custom-text text-left fw-bold pt-2">Chọn tệp tải lên</span>
          <el-upload
            class="upload-demo"
            :auto-upload="false"
            :file-list="fileList"
            :on-change="onFileChange"
            action="">
            <el-input
              style="width: 314px"
              placeholder="Chọn tệp...">
              <template slot="append">Tìm</template>
            </el-input>
          </el-upload>
        </div>
      </div>
      <div
        class="d-flex justify-content-between align-items-center mt-3"
        style="margin-bottom: 5px">
        <div class="d-flex align-items-center">
          <icon-v-2
            name="v2-info1"
            color="#FDAF36"></icon-v-2>
          <span style="color: #7a7f83; margin-left: 3px">Chú ý: Tối đa 50 tin nhắn mẫu</span>
        </div>
        <div class="dialog-footer">
          <el-button @click="showExcelDialog = false">Hủy</el-button>
          <el-button
            type="primary"
            @click="uploadExcelData">
            Tải lên
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      center
      title="Sửa tin nhắn"
      :visible.sync="dialogVisible"
      width="50%">
      <div style="margin-top: -20px"></div>

      <div style="margin: 4px">
        <el-input
          size="medium"
          v-model="selectedMessage.code"
          placeholder="Mã"
          type="text"></el-input>
      </div>

      <div style="margin: 4px; position: relative">
        <el-input
          :rows="6"
          size="medium"
          type="textarea"
          v-model="selectedMessage.content"
          placeholder="Nhập nội dung tin nhắn"></el-input>
        <div @click="triggerFileSelect">
          <icon-v-2
            name="v2-image"
            style="position: absolute; bottom: 10px; right: 10px; cursor: pointer"
            class="p-1 pointer pin rounded-1 font-size-20 flex-1"
            size="20px"></icon-v-2>
        </div>
        <input
          style="display: none; width: 0; height: 0"
          ref="file"
          type="file"
          multiple
          accept="image/png, image/gif, image/jpeg, image/jpg"
          @change="handleFileSelect" />
      </div>
      <div class="px-2 d-flex flex-wrap mt-3 align-items-center">
        <div
          class="d-flex align-items-center justify-content-center me-1 position-relative"
          v-for="item in splitComma(selectedMessage.ids)"
          :key="item"
          style="width: 56px; height: 56px">
          <File :id="item" />
          <i
            class="el-icon-error position-absolute pointer icon-hover"
            @click="removeImageFromSelectMessage(item)"
            style="top: 4px; right: 4px; color: #cf4343; cursor: pointer"></i>
        </div>

        <div
          class="d-flex align-items-center justify-content-center me-1 position-relative"
          v-for="(image, index) in imagePreviews"
          :key="'new-' + index">
          <img
            :src="image"
            alt="Image Preview"
            style="width: 56px; height: 56px; border-radius: 2px; margin-top: -6px" />
          <i
            class="el-icon-error position-absolute pointer icon-hover"
            @click="removeImagePreview(index)"
            style="top: 2px; right: 4px; color: #cf4343; cursor: pointer"></i>
        </div>
      </div>

      <div style="position: relative; height: 32px">
        <el-button
          size="mini"
          style="position: absolute; right: 0; top: 4px"
          type="primary"
          @click="updateMessage(selectedMessage)">
          Lưu
        </el-button>
      </div>
    </el-dialog>

    <div
      class="d-flex"
      style="min-height: calc(100vh - 78px); max-height: calc(100vh - 78px)">
      <div
        class="d-flex flex-column align-items-center"
        style="max-width: 368px; width: 100%; background-color: #fafafa">
        <div
          class="d-flex justify-content-between align-items-center mt-2"
          style="width: 312px; height: 36px">
          <div
            class="font-size-18 fw-bold"
            style="text-align: left">
            Tin nhắn mẫu
          </div>
          <el-button
            class="d-flex align-items-center font-size-14"
            @click="showExcelDialog = true"
            style="
              width: 134px;
              height: 36px;
              background-color: #3484f0;
              color: white;
              border-radius: 4px;
              border: 1px solid #3484f0;
              display: flex;
              align-items: center;
              justify-content: center;
            ">
            <div class="d-flex">
              <icon-v-2
                name="v2-import"
                color="white"
                style="margin-right: 8px; vertical-align: middle"></icon-v-2>
              Nhập file Excel
            </div>
          </el-button>
        </div>
        <div class="d-flex flex-column align-items-center mt-3 w-100">
          <el-select
            v-model="accountId"
            @change="getMessage"
            filterable
            size="medium"
            default-first-option
            placeholder="Tìm kiếm tài khoản..."
            style="width: 312px">
            <el-option
              label="Tất cả Tài khoản"
              class="uppercase-label"
              :value="0"></el-option>
            <el-option
              v-for="account in app.accounts"
              :key="account.accountId"
              :label="account.swName || account.displayName"
              :value="account.accountId"></el-option>
          </el-select>
          <div
            class="d-flex mt-3"
            style="width: 312px">
            <el-input
              placeholder="Nhập mã tin nhắn mẫu"
              v-model="quickReply.code">
              <template slot="prepend">/</template>
            </el-input>
          </div>

          <div style="position: relative; width: 312px">
            <el-input
              v-model="quickReply.content"
              type="textarea"
              :rows="6"
              placeholder="Nhập nội dung tin nhắn"
              size="medium"
              class="mt-3"
              style="width: 100%"></el-input>
            <div @click="$refs.file1.click()">
              <icon-v-2
                name="v2-image"
                style="position: absolute; bottom: 10px; right: 40px"
                class="p-1 pointer pin rounded-1 font-size-20 flex-1"
                size="20px"></icon-v-2>
            </div>
            <el-popover
              placement="top"
              trigger="click"
              v-model="stickerVisible">
              <el-button
                slot="reference"
                style="position: absolute; bottom: 10px; right: 15px; border: none"
                class="p-1 pointer pin rounded-1 v2-emoji font-size-20 flex-1" />
              <EmojiPicker @emoji-click="EmojiPickup" />
            </el-popover>
          </div>

          <div
            class="d-flex justify-content-left mt-3"
            style="width: 312px">
            <div
              class="position-relative me-2 rounded"
              v-for="(item, index) in files1"
              :key="index">
              <div>
                <el-image
                  :src="getUrl(item)"
                  style="object-fit: cover">
                  <div
                    slot="error"
                    class="image-slot">
                    <i class="el-icon-picture font-size-32 rounded-1"></i>
                  </div>
                </el-image>
                <i
                  class="icon-hover el-icon-error pointer position-absolute"
                  style="top: 4px; right: 4px; color: #cf4343"
                  @click="removeImage(index)"></i>
              </div>
            </div>
            <input
              style="display: none; width: 0; height: 0"
              ref="file1"
              type="file"
              multiple
              accept="image/png, image/gif, image/jpeg, image/jpg"
              @change="fileSelected" />
          </div>
        </div>

        <div class="d-flex justify-content-center mt-2 w-100">
          <el-button
            :disabled="!isDisable"
            type="info"
            size="mini"
            class="mt-2"
            style="width: 312px; height: 40px; opacity: 0px; font-size: 14px; text-transform: none"
            @click="saveMessage(quickReply)">
            Tạo tin nhắn mẫu
          </el-button>
        </div>
      </div>

      <div style="width: 100%; background-color: #ffffff">
        <div
          class="d-flex justify-content-between align-items-center w-100 mb-2 mt-1"
          style="padding: 0 16px">
          <div class="d-flex align-items-center m-2 font-size-18 fw-bold">
            <span>Danh sách tin nhắn mẫu</span>
            <button
              class="d-flex align-items-center font-size-14"
              style="width: 129px; height: 32px; background: #d4e4ff6e; color: #2970dd; border-radius: 4px; border: 1px solid #3484f0; margin-left: 16px"
              @click="exportToExcel">
              <icon-v-2
                class="space"
                name="v2-export"
                color="#2970DD"></icon-v-2>
              Xuất file Excel
            </button>
          </div>
          <div class="d-flex flex-1 justify-content-end">
            <el-input
              class="custom-input"
              size="medium"
              style="width: 200px; margin-right: 10px"
              v-model="searchKey"
              placeholder="Tìm kiếm">
              <IconV2
                slot="prefix"
                class="my-2-5 ms-1"
                name="v2-search" />
            </el-input>
            <el-select
              v-model="accountId"
              @change="getMessage"
              filterable
              size="medium"
              default-first-option
              placeholder="Tìm kiếm tài khoản...">
              <el-option
                label="Tất cả tài khoản"
                :value="0"></el-option>
              <el-option
                v-for="account in app.accounts"
                :key="account.accountId"
                :label="account.swName || account.displayName"
                :value="account.accountId"></el-option>
            </el-select>
          </div>
        </div>

        <div
          class="mx-2 flex-grow-1 bg-white"
          style="border: 1px solid #dcdfe9; border-radius: 4px; height: 70vh; overflow-y: auto">
          <div
            class="d-flex font-size-13 p-2"
            style="background-color: #fafafa; height: 36px">
            <div style="text-align: left; width: 20%">
              <div
                class="font-size-14 fw-bold ms-4"
                style="color: #696b72; font-family: Arial; font-size: 14px; font-weight: 700; line-height: 20px; letter-spacing: 0.01em; text-align: left">
                Mã
              </div>
            </div>
            <div
              class="flex-1"
              style="width: 75%">
              <div
                class="font-size-14 fw-bold"
                style="color: #696b72; font-family: Arial; font-size: 14px; font-weight: 700; line-height: 20px; letter-spacing: 0.01em; text-align: left">
                Tin nhắn
              </div>
            </div>
            <div style="text-align: right; width: 15%">
              <div class="d-flex">
                <div
                  class="font-size-14 fw-bold"
                  style="color: #696b72; font-family: Arial; font-size: 14px; font-weight: 700; line-height: 20px; letter-spacing: 0.01em; text-align: left">
                  Thao tác
                </div>
              </div>
            </div>
          </div>

          <div style="border-top: 1px solid #dcdfe9"></div>
          <div
            v-for="quick in filteredMessages"
            :key="quick.id">
            <div class="d-flex font-size-13 p-2">
              <div
                class="d-flex align-items-center text-wrap"
                style="width: 20%; word-break: break-word">
                <div class="d-flex align-items-center">
                  <icon-v-2
                    class="space"
                    name="fa-solid fa-grip-vertical"
                    style="margin-right: 8px"></icon-v-2>
                  <div class="fw-bold font-size-13">/{{ quick.code }}</div>
                </div>
              </div>

              <div
                class="flex-1 text-wrap align-items-center"
                style="text-align: left; width: 75%; word-break: break-word">
                <div class="px-2 font-size-13">{{ quick.content }}</div>
                <div class="px-2 d-flex flex-wrap">
                  <div
                    class="me-1"
                    v-for="item in quick.urls"
                    :key="item.id">
                    <FileV3 :item="item" />
                  </div>
                </div>
              </div>

              <div
                style="text-align: right; width: 15%"
                class="d-flex align-items-center">
                <el-button
                  size="mini"
                  type="primary"
                  style="width: 28px; height: 28px; padding: 2px 0px 2px 0px; gap: 4px; border-radius: 4px; opacity: 0px"
                  @click="chooseMessage(quick)">
                  <div>
                    <icon-v-2
                      name="fa fa-pen"
                      slot="prefix"
                      color="white"
                      size="13px" />
                  </div>
                </el-button>
                <el-button
                  size="mini"
                  @click="deleteMessage(quick)"
                  style="width: 28px; height: 28px; padding: 2px 0px 2px 0px; gap: 4px; border-radius: 4px; opacity: 0px">
                  <icon-v-2
                    name="fa fa-trash"
                    color="#D91B1B"
                    size="13px"></icon-v-2>
                </el-button>
              </div>
            </div>

            <div
              style="border-top: 1px solid #dcdfe9"
              class="mx-2 my-1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageLibraryPopup from "./ImageLibraryPopup";
import FileV3 from "./imageLibSetting/FileV3";
import File from "./imageLibSetting/File";
import EmojiPicker from "./message/EmojiPicker";
import * as XLSX from "xlsx";

export default {
  components: {
    FileV3,
    File,
    ImageLibraryPopup,
    EmojiPicker,
  },
  data() {
    return {
      multiple: false,
      quickReply: {
        id: 0,
        accountId: 0,
        content: "",
        code: "",
      },
      accountId: 0,
      dialogVisible: false,
      selectedMessage: {
        code: "",
        content: "",
        ids: "",
        accountId: 0,
      },
      files1: [],
      imagePreviews: [],
      tableHeight: 0,
      currentTab: "",
      isShowImageLibraryPopup: false,
      files: [],
      MAX_SIZE: 5,
      LENGTH: 5,
      searchKey: "",
      quickReplyListshow: [],
      quickMessages: [],
      quickMessageShows: [],
      stickerVisible: false,
      showExcelDialog: false,
      fileList: [],
      excelData: [],
    };
  },
  computed: {
    isDisable() {
      return this.quickReply.content !== "" && this.quickReply.code !== "";
    },
    filteredMessages() {
      const filtered = this.quickMessages.filter((msg) => {
        if (this.accountId !== 0 && msg.accountId !== this.accountId) {
          return false;
        }
        if (
          this.searchKey.length > 0 &&
          !msg.content.toLowerCase().includes(this.searchKey.toLowerCase()) &&
          !msg.code.toLowerCase().includes(this.searchKey.toLowerCase())
        ) {
          return false;
        }
        return true;
      });
      return filtered.sort((a, b) => a.code.localeCompare(b.code));
    },
  },
  methods: {
    triggerFileSelect() {
      this.$refs.file.click();
    },
    handleFileSelect(event) {
      const files = event.target.files;

      const maxSizeMB = 5;
      const maxFiles = 5;

      if (files.length > maxFiles) {
        this.$message.error(`Bạn chỉ được phép tải tối đa ${maxFiles} ảnh`);
        return;
      }

      for (let file of files) {
        if (file.size / 1024 / 1024 > maxSizeMB) {
          this.$message.error(`Kích thước tối đa ${maxSizeMB}MB`);
          return;
        }
      }

      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreviews.push(e.target.result);
          this.files.push(file);
        };
        reader.readAsDataURL(file);
      });

      this.$refs.file.value = "";
    },
    removeImageFromSelectMessage(index) {
      let images = this.selectedMessage.ids ? this.selectedMessage.ids.split(",") : [];

      images.splice(index, 1);

      this.selectedMessage.ids = images.join(",");
    },
    removeImagePreview(index) {
      this.imagePreviews.splice(index, 1);
      this.files.splice(index, 1);
    },
    splitComma(ids) {
      return ids ? ids.split(",") : [];
    },

    searchQuickReplyList() {
      this.filterMessagesByAccount();
    },

    removeImage(index) {
      this.files1.splice(index, 1);
    },
    getUrl(item) {
      return URL.createObjectURL(item);
    },
    fileSelected(e) {
      let selectedFiles = e.target.files;
      let lens = selectedFiles.length;

      for (let i = 0; i < lens; i++) {
        if (selectedFiles[i].size / 1024 / 1024 > this.MAX_SIZE) {
          this.$refs.file1.value = "";
          return this.alertError("Kích thước tối đa " + this.MAX_SIZE + "MB");
        }
      }
      if (this.files1.length + lens > this.LENGTH) {
        this.$refs.file1.value = "";
        return this.alertError("Bạn chỉ được phép tải tối đa " + this.LENGTH + " ảnh");
      }
      this.files1 = [...this.files1, ...selectedFiles];

      this.$refs.file1.value = "";
    },

    async saveMessage(quickReply) {
      quickReply.accountId = this.accountId;

      if (this.checkEmptyContent(quickReply)) {
        this.alert("error", "Tin nhắn không hợp lệ");
        return;
      }

      const isDuplicate = this.quickMessages.some((message) => message.code === quickReply.code);
      if (isDuplicate) {
        this.alert("error", "Mã tin đã tồn tại");
        return;
      }

      let arr = [];

      if (this.files1.length > 0) {
        arr = await this.upload1();
        this.$refs.file1.value = null;
        this.files1 = [];
      }

      if (arr.length > 0) {
        quickReply.ids = arr.join(",");
      }

      try {
        const res = await this.$http.post("/api/quickMessageConfig/save", quickReply);

        if (res.status === "success") {
          this.alert("success", "Lưu tin nhắn thành công");
          this.app.quickReplyList = this.app.quickReplyList.filter((q) => q.accountId !== this.accountId);

          this.app.quickReplyList.push(res.data);

          this.app.quickReplyList.sort((a, b) => a.code.localeCompare(b.code));

          this.quickReply = {
            content: "",
            code: "",
            accountId: 0,
          };
          this.getMessage();
        }
      } catch (ex) {
        if (ex.response && ex.response.data && ex.response.data.error.message === "Existed name") {
          this.alert("error", "Mã tin đã tồn tại");
        } else {
          this.alert("error", "Mã tin đã tồn tại");
        }
      }
    },

    async updateMessage(quickReply) {
      quickReply.accountId = this.accountId;

      if (this.checkEmptyContent(quickReply)) {
        this.alert("error", "Tin nhắn không hợp lệ");
        return;
      }

      let newUploadedImages = [];
      if (this.files.length > 0) {
        try {
          newUploadedImages = await this.upload();
          this.$refs.file.files = null;
        } catch (error) {
          this.alert("error", "Lỗi khi tải ảnh lên");
          return;
        }
      }

      let existingImages = this.splitComma(quickReply.ids);
      quickReply.ids = existingImages.concat(newUploadedImages).join(",");

      try {
        const response = await this.$http.put(`/api/quickMessageConfig/update`, quickReply);
        if (response.status === "success") {
          this.alert("success", "Cập nhật tin nhắn thành công");
          this.app.quickReplyList = this.app.quickReplyList.filter((q) => q.id !== quickReply.id);

          this.app.quickReplyList.push(response.data);
          this.app.quickReplyList.sort((a, b) => a.code.localeCompare(b.code));
          this.quickReply = {
            content: "",
            code: "",
            accountId: 0,
          };
          this.getMessage();
          this.files = [];
          this.imagePreviews = [];
          this.selectedMessage.ids = "";

          this.dialogVisible = false;
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error.message === "Existed name") {
          this.alert("error", "Mã tin đã tồn tại");
        } else {
          this.alert("error", "Có lỗi xảy ra khi cập nhật tin nhắn");
        }
      }
    },

    async upload() {
      let arr = [];
      for (let file of this.files) {
        try {
          let fileName = await this.uploadItem(file);
          if (fileName) {
            arr.push(fileName);
          } else {
            this.alert("error", `Lỗi khi tải lên file: ${file.name}`);
          }
        } catch (error) {
          this.alert("error", `Không thể tải lên file: ${file.name}`);
        }
      }
      return arr;
    },
    async upload1() {
      let arr = [];
      for (let file of this.files1) {
        try {
          console.log("Đang tải lên tệp:", file);

          let fileName = await this.uploadItem(file);
          if (fileName) {
            arr.push(fileName);
            console.log(`Tệp ${file.name} đã tải lên thành công với tên: ${fileName}`);
          } else {
            this.alert("error", `Lỗi khi tải lên file: ${file.name}`);
          }
        } catch (error) {
          this.alert("error", `Không thể tải lên file: ${file.name}`);
          console.error("Chi tiết lỗi:", error);
        }
      }
      return arr;
    },

    uploadItem(item) {
      var bodyFormData = new FormData();
      bodyFormData.append("file", item);
      return this.$http
        .post("/api/image/upload", bodyFormData)
        .then((s) => s.data)
        .catch((ex) => this.alertError(ex.error.message));
    },
    onFileChange(file, fileList) {
      if (fileList.length > 1) {
        this.$message.error("Lỗi: Chỉ được phép tải lên một file.");
        this.fileList = fileList.slice(0, 1);
        return;
      }
      this.fileList = fileList;

      const reader = new FileReader();
      reader.onload = async (event) => {
        try {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          let rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          const headers = rawData[0];
          if (!headers || headers.length !== 3 || headers[0] !== "Mã" || headers[1] !== "Tin nhắn" || headers[2] !== "Đường dẫn ảnh") {
            this.$message.error("Lỗi: Vui lòng chọn file đúng Mẫu.");
            this.fileList = [];
            return;
          }
          if (headers.some((header) => !["Mã", "Tin nhắn", "Đường dẫn ảnh"].includes(header))) {
            this.$message.error("Lỗi: Vui lòng chọn file đúng Mẫu.");
            this.fileList = [];
            return;
          }

          rawData = XLSX.utils.sheet_to_json(worksheet);

          // Chỉ tính các row có dữ liệu thật (Mã + Tin nhắn non-empty); các row trống/whitespace
          // trong file Excel không được tính vào limit 50.
          const validRows = rawData.filter((row) => {
            const code = row["Mã"] != null ? String(row["Mã"]).trim() : "";
            const content = row["Tin nhắn"] != null ? String(row["Tin nhắn"]).trim() : "";
            return code !== "" && content !== "";
          });

          if (validRows.length > 50) {
            this.$message.error("Lỗi: File Excel chứa hơn 50 bản ghi.");
            this.fileList = [];
            return;
          }

          this.temporaryData = [];
          const uniqueCodes = new Set();
          const existingCodes = new Set(this.quickMessages.map((msg) => msg.code));

          for (const row of validRows) {
            let code = row["Mã"];
            let content = row["Tin nhắn"];

            code = code ? String(code).trim() : "";
            content = content ? String(content).trim() : "";

            if (code === "" || uniqueCodes.has(code) || existingCodes.has(code) || content === "") {
              continue;
            }

            uniqueCodes.add(code);

            const messageData = {
              code: code,
              content: content,
              accountId: this.accountId,
              ids: "",
            };

            if (row["Đường dẫn ảnh"]) {
              const urls = row["Đường dẫn ảnh"].split(",");
              const imageIds = [];

              for (const url of urls) {
                try {
                  const imageId = await this.downloadImageFromUrl(url.trim());
                  imageIds.push(imageId);
                } catch (error) {
                  console.error(`Không thể tải ảnh từ URL: ${url.trim()}`, error);
                }
              }

              if (imageIds.length > 0) {
                messageData.ids = imageIds.join(",");
              }
            }

            this.temporaryData.push(messageData);
          }
          if (this.temporaryData.length === 0) {
            this.$message.error("Mã tin đã tồn tại.");
            this.fileList = [];
            return;
          }
          console.log("Dữ liệu sau khi xử lý:", this.temporaryData);
        } catch (error) {
          console.error("Lỗi khi đọc file:", error);
          this.fileList = [];
        }
      };

      reader.readAsArrayBuffer(file.raw);
    },

    async uploadExcelData() {
      try {
        const response = await this.$http.post("/api/quickMessageConfig/saveMultiple", this.temporaryData, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status === "success") {
          this.$message.success("Dữ liệu tải lên thành công!");
          this.showExcelDialog = false;
          await this.getMessage();
        } else {
          throw new Error("Dữ liệu tải lên thất bại.");
        }
      } catch (error) {
        this.$message.error("Vui lòng chọn file để tải lên!");
      }
    },

    async downloadImageFromUrl(url) {
      try {
        const response = await fetch(url);
        console.log("sssssss", response);
        if (!response.ok) {
          throw new Error("Tải ảnh không thành công");
        }
        console.log("fail1");
        const blob = await response.blob();
        console.log("fail12");

        let bodyFormData = new FormData();
        bodyFormData.append("file", blob, "downloaded_image.jpg");

        const uploadResponse = await this.$http.post("/api/image/upload", bodyFormData);

        if (!uploadResponse || !uploadResponse.data) {
          throw new Error("Upload ảnh không thành công");
        }

        return uploadResponse.data;
      } catch (error) {
        console.error("Lỗi khi tải và upload ảnh:", error);
        throw error;
      }
    },

    chooseMessage(msg) {
      this.selectedMessage = JSON.parse(JSON.stringify(msg));
      this.dialogVisible = true;
    },
    deleteMessage(quick) {
      this.$confirm("Bạn muốn xoá mẫu tin này?", "Warning", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      }).then(async () => {
        try {
          await this.$http.delete("api/quickMessageConfig", {
            params: {
              id: quick.id,
              accountId: this.accountId,
            },
          });
          this.app.quickReplyList = this.app.quickReplyList.filter((q) => q.id !== quick.id);
          this.app.quickReplyList.sort((a, b) => a.code.localeCompare(b.code));
          console.log("ssssss", this.app.quickReplyList);
          await this.getMessage();
          this.alert("success", "Xóa tin nhắn thành công");
        } catch (error) {
          this.alert("error", "Có lỗi xảy ra khi xóa tin nhắn");
        }
      });
    },

    downloadExcel() {
      const wb = XLSX.utils.book_new();
      const ws_data = [["Mã", "Tin nhắn", "Đường dẫn ảnh"]];
      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      XLSX.utils.book_append_sheet(wb, ws, "Template");
      XLSX.writeFile(wb, "MauTinNhan.xlsx");
    },
    exportToExcel() {
      const wb = XLSX.utils.book_new();
      const ws_data = [["Mã", "Tin nhắn", "Đường dẫn ảnh"]];

      for (let message of this.quickMessages) {
        let imageUrls = message.ids
          ? message.ids
              .split(",")
              .map((id) => this.getUrlImage(id))
              .join(", ")
          : "";

        ws_data.push([message.code, message.content, imageUrls]);
      }

      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      XLSX.utils.book_append_sheet(wb, ws, "Tin nhắn mẫu");

      XLSX.writeFile(wb, "TinNhanMau.xlsx");
    },

    checkEmptyContent(request) {
      return request.code.trim() === "" || request.content.trim() === "";
    },
    getMessage() {
      this.$http
        .get("/api/quickMessageConfig", {
          params: {
            accountId: this.accountId,
          },
        })
        .then((resp) => {
          this.quickMessages = resp.data;
          if (this.quickMessages.length > 0) {
            this.quickMessages = this.quickMessages.sort((s, s1) => new Date(s1.createAt).getTime() - new Date(s.createAt).getTime());
            this.filterMessagesByAccount();
          }
        });
    },
    filterMessagesByAccount() {
      this.searchKey = this.searchKey.toLowerCase();
    },

    EmojiPickup(emoji) {
      this.quickReply.content += emoji.native || emoji;
    },
  },

  created() {
    this.getMessage();

    this.$bus.$on("emoji_click", (data) => {
      this.EmojiPickup(data);
    });
  },
  updated() {
    this.tableHeight = window.innerHeight - 150;
  },
  watch: {
    showExcelDialog(newVal) {
      if (!newVal) {
        this.fileList = [];
      }
    },
  },
};
</script>

<style scoped>
.space {
  margin-right: 8px;
}
.my-2-5 {
  margin-top: 0.625rem !important;
  margin-bottom: 0.625rem !important;
}
.uppercase-label .el-option__content {
  text-transform: uppercase !important;
}
.custom-input .el-input__inner {
  height: 36px !important;
  width: 200px;
  line-height: 36px;
}

.input-with-box .input-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  background: #dcdfe9;
  font-size: 16px;
  font-weight: bold;
}
.el-input__prefix {
  left: 0px !important;
}
.custom-code.el-input__inner {
  padding-left: 40px !important;
}
.el-image {
  height: 56px !important;
  width: 56px !important;
  border-radius: 2px;
}
.input-prefix {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 10px;
  background-color: #dcdfe9;
  border-right: 1px solid #dcdfe6;
  width: 40px;
  color: black;
  border-radius: 4px 0 0 4px !important;
}

.position-relative {
  position: relative;
}

.icon-hover {
  color: red;
  cursor: pointer;
  font-size: 16px;
}

.image-container img {
  width: 100%;
  height: auto;
}

.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.custom-dialog .el-dialog__header {
  text-align: center;
}

.custom-dialog .el-dialog__header .el-dialog__title {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: center; /* Center the title */
  text-transform: uppercase;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  display: flex;
}
.custom-text {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
}
.custom-account .el-input__inner {
  height: 32px !important;
}

.el-input__prefix {
  left: 0px !important;
}

.upload-demo >>> .el-upload-list__item-name {
  max-width: 250px;
}
.icon-hover:hover {
  color: red !important; /* Màu đỏ khi di chuột vào */
}
</style>
